export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.d7f54928.gif";